export interface ISandboxConfig {
  message: string;
  layout: {
    globalProps: { prop: string; valueType: string }[];
  };
  spacing: { slug: string; value: string }[];
  contexts: { hook: string; values: string[] }[];
}

export const sandboxConfig: ISandboxConfig = {
  message: 'Hello World',
  layout: {
    globalProps: [
      // general padding
      { prop: 'noPadding', valueType: 'boolean' },
      { prop: 'extraSmallPadding', valueType: 'boolean' },
      { prop: 'smallPadding', valueType: 'boolean' },
      { prop: 'basePadding', valueType: 'boolean' },
      { prop: 'largePadding', valueType: 'boolean' },
      { prop: 'extraLargePadding', valueType: 'boolean' },
      { prop: 'hugePadding', valueType: 'boolean' },
      // specific padding
      { prop: 'paddingTop', valueType: 'string' },
      { prop: 'paddingRight', valueType: 'string' },
      { prop: 'paddingBottom', valueType: 'string' },
      { prop: 'paddingLeft', valueType: 'string' },
      // preset padding
      { prop: 'noHorizontalPadding', valueType: 'boolean' },
      { prop: 'extraSmallHorizontalPadding', valueType: 'boolean' },
      { prop: 'smallHorizontalPadding', valueType: 'boolean' },
      { prop: 'horizontalPadding', valueType: 'boolean' },
      { prop: 'largeHorizontalPadding', valueType: 'boolean' },
      { prop: 'extraLargeHorizontalPadding', valueType: 'boolean' },
      { prop: 'hugeHorizontalPadding', valueType: 'boolean' },
      { prop: 'noVerticalPadding', valueType: 'boolean' },
      { prop: 'extraSmallVerticalPadding', valueType: 'boolean' },
      { prop: 'smallVerticalPadding', valueType: 'boolean' },
      { prop: 'verticalPadding', valueType: 'boolean' },
      { prop: 'largeVerticalPadding', valueType: 'boolean' },
      { prop: 'extraLargeVerticalPadding', valueType: 'boolean' },
      { prop: 'hugeVerticalPadding', valueType: 'boolean' },
      // specific margin
      { prop: 'marginTop', valueType: 'string' },
      { prop: 'marginRight', valueType: 'string' },
      { prop: 'marginBottom', valueType: 'string' },
      { prop: 'marginLeft', valueType: 'string' },
    ],
  },
  spacing: [
    { slug: 'base', value: '16px' },
    { slug: 'none', value: '0px' },
    { slug: 'extraSmall', value: '4px' },
    { slug: 'small', value: '8px' },
    { slug: 'medium', value: '16px' },
    { slug: 'large', value: '24px' },
    { slug: 'extraLarge', value: '32px' },
    { slug: 'huge', value: '64px' },
  ],
  contexts: [
    { hook: 'useBaseStore()', values: ['classes', 'location', 'session', 'user'] },
    { hook: 'useBaseState()', values: ['isNavExpanded', 'mediaSize', 'totalHeight', 'totalWidth'] },
    {
      hook: 'usePanel()',
      values: ['colors', 'fontColors', 'theme', 'type', 'width', 'height', 'panelSize'],
    },
  ],
};
